import { getOidcClient } from "./getOidcClient";
import { SignInOutput, SigninResponseProxied } from "./signIn";

export async function processSignInResponse(): Promise<SignInOutput> {
  return getOidcClient()
    .processSigninResponse()
    .then(function (
      // eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
      response
    ) {
      return {
        tag: "data" as const,
        data: response as unknown as SigninResponseProxied,
      };
    })
    .catch(function (error) {
      return {
        tag: "errors",
        errors: [],
        uuid: "9db7ebdc-8f44-4355-a785-85148650c0b9",
      };
    });
}
